import React, { useContext } from "react";
import Report from "views/Statistics/Report/Hourly/component";
import ActionsContext from "common/ActionsContext";
import MarkdownHelpModal from "common/MarkdownHelpModal";
import help from "help/viewHTTPCompressionHourlyVolumeAndRatio.md";
import { getBqnIdCmdPart } from "common/api";
import { parseVolumeHourly, parseRatioHourly } from "./api";
import { Header } from "common/Header";
import { hoursScopeChoices } from "common/constants";
import timeAndValuesTooltipForUnits from "common/graphs/timeAndValuesTooltip";

const ContextMenu = () => {
  const actions = useContext(ActionsContext);
  return (
    <ul className="context-menu header-dropdown m-r--5">
      <a
        data-loading-effect="pulse"
        data-toggle="cardloading"
        title="Help"
        onClick={() => actions.send("open-help")}
      >
        <i className="material-icons">help_outline</i>
      </a>
      <a
        onClick={() => actions.send("do-load")}
        data-toggle="cardloading"
        data-loading-effect="pulse"
        title="Refresh"
      >
        <i className="material-icons">refresh</i>
      </a>
    </ul>
  );
};
const hoursToLines = (hours) =>
  hours === 24 ? 288 : hours === 24 * 7 ? 2016 : 8640; /*month max*/

const doSpeedShareRetrieval = (hours = 72, bqnId, mode) =>
  ifCl.run(
    `show statistics compress lines ${hoursToLines(hours)} ${getBqnIdCmdPart(
      mode,
      bqnId
    )}`
  );

const retrieval = ({ hours, volumeOrRatio, bqnId, mode }) =>
  doSpeedShareRetrieval(hours, bqnId, mode)
    .then(volumeOrRatio === "ratio" ? parseRatioHourly : parseVolumeHourly)
    .then((readings) => ({ readings }))
    .catch((error) => console.error(error) || error);

const enabledFeatures = () => ({
  volumeOrRatio: true,
  hours: true,
  policyType: false,
  directions: false,
  categories: false,
  filter: false,
  output: false,
  target: false,
});

const monthOrLess = ({ value }) => value <= 720;
const customSettings = {
  hours: { options: hoursScopeChoices.filter(monthOrLess) },
};
const doesNothing = () => {};
const HTTPCompressionHourlyVolumeAndRatio = () => {
  const actions = useContext(ActionsContext);

  return (
    <div
      id="viewHTTPCompressionHourlyVolumeAndRatio"
      className="col-lg-12 col-md-12 col-sm-12 col-xs-12"
    >
      <div className="card">
        <Header title="BTC Statistics" contextMenu={<ContextMenu />} />
        <div className="body flex-panel-column">
          <Report
            graphTitle={null}
            provider={retrieval}
            onSeriesInspect={doesNothing}
            enabled={enabledFeatures()}
            settings={customSettings}
            actions={actions}
            stacked={false}
            from="readings"
            itemsFrom="series"
            itemsValueFrom="value"
            yAxisUnits={({ volumeOrRatio }) =>
              volumeOrRatio === "ratio" ? "%" : "MB"
            }
            fixedYRange={[0, null]}
            tooltipContentGenerator={(units) =>
              timeAndValuesTooltipForUnits(units, undefined, false, false)
            }
          />
        </div>
        <MarkdownHelpModal title="BTC Statistics" source={help} />
      </div>
    </div>
  );
};

export default HTTPCompressionHourlyVolumeAndRatio;
